import { render } from "./agentInfo.vue?vue&type=template&id=0cc3f3a2"
import script from "./agentInfo.vue?vue&type=script&lang=js"
export * from "./agentInfo.vue?vue&type=script&lang=js"

import "./agentInfo.vue?vue&type=style&index=0&id=0cc3f3a2&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-detail-info/agentInfo.vue'],['render',render],['__file',"agentInfo.vue"]])

export default __exports__